module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24,
      "loading": _vm.loading
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("设置")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("个人信息")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "warp-main",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.useranme),
      callback: function($$v) {
        _vm.$set(_vm.form, "useranme", $$v)
      },
      expression: "form.useranme"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "nickname",
      "label": "昵称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "nickname", $$v)
      },
      expression: "form.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "邮箱"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSaveProfile
    }
  }, [_vm._v("修改并保存")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f4fa6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/profile.vue
// module id = 1156
// module chunks = 2